import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "advanced-potion-making-edition-IV",
  name: `Advanced Potion-Making\nEdition IV`,
  nameFormatted: {
    primary: "Advanced Potion-Making",
    secondary: "Edition IV",
  },
  origin: "Harry Potter and the Half-Blood Prince",

  sort: {
    preferredIndex: 2,
  },

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
